import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Stable vs variable APR' },
  shortTitle: { defaultMessage: 'Variable APR' },
  graphDotStable: { defaultMessage: 'Stable' },
  graphDotVariable: { defaultMessage: 'Variable' },
});
